(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 67740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    isArrayLike = __webpack_require__(98612),
    keys = __webpack_require__(3674);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 13311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFind = __webpack_require__(67740),
    findIndex = __webpack_require__(30998);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ 30998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIteratee = __webpack_require__(67206),
    toInteger = __webpack_require__(40554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 40554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(18601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6200);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25935);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2962);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88518);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15072);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38864);
/* harmony import */ var src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84233);
/* harmony import */ var src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84920);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34892);
/* harmony import */ var src_utils_datasets__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(34871);
/* harmony import */ var src_utils_device__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(25283);
/* harmony import */ var src_utils_devices__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97348);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39334);
/* harmony import */ var src_utils_useUser__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(51148);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(186);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  #spacial-commemorate {\n    position: relative;\n    margin-top: 0px;\n    .spacial-grid {\n      padding: 16rem 1rem 2rem !important;\n      @media (max-width: 1024px) {\n        padding: 9rem 0.75rem 0rem !important;\n      }\n    }\n    .card-v-content-meta {\n      margin-top: 5px;\n    }\n    .card-v-thumb {\n      margin-bottom: 10px;\n    }\n    .more {\n      color: #fff;\n      position: absolute;\n      bottom: 11px;\n      right: 30px;\n      font-size: 16pt;\n      :hover {\n        color: #ffffff92;\n      }\n    }\n    @media (max-width: 767px) {\n      .card-v {\n        min-height: 133px;\n      }\n      .card-v-content-title {\n        font-size: 16pt;\n        min-height: 56px;\n      }\n      .card-v-content-meta {\n        font-size: 10pt;\n      }\n    }\n  }\n  #spacial-commemorate {\n    background-position: top;\n    @media (min-width: 767px) and (max-width: 1024px) {\n      background-size: contain;\n      background-position: top center;\n      background-color: black;\n    }\n\n    .spacial-grid {\n      padding: 20rem 1rem 2rem;\n      @media (max-width: 1024px) {\n        padding: 11rem 1rem 0rem;\n      }\n    }\n    .spacial-card {\n      border-radius: 8px;\n    }\n    .spacial-grid-list .row {\n      grid-gap: 20px;\n      grid-template-columns: 1fr 1fr 1fr 1fr;\n      @media (max-width: 1024px) {\n        grid-template-columns: 1fr 1fr 1fr 1fr;\n        grid-template-areas: '--item-1 --item-2 --item-3 --item-4 ';\n        .card-v {\n          min-height: 140px;\n        }\n      }\n      @media (max-width: 690px) {\n        grid-template-columns: 1fr 1fr 1fr;\n        grid-gap: 5px;\n        grid-template-areas: '--item-1 --item-2 --item-3';\n        .card-v {\n          min-height: 100px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





















// Below-the-fold sections stay client-only (ssr:false) to keep INP low.
// Above-the-fold LCP content must be SSR'd so it paints from server HTML (not after hydration).
// Layout must be SSR-enabled for initial page structure
var Layout = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 75519));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75519)
            ];
        }
    },
    ssr: true
});
var SectionLandingPage = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return __webpack_require__.e(/* import() */ 8590).then(__webpack_require__.bind(__webpack_require__, 38590));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38590)
            ];
        }
    },
    ssr: false
});
var SectionSpacial = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return __webpack_require__.e(/* import() */ 2784).then(__webpack_require__.bind(__webpack_require__, 52784));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52784)
            ];
        }
    },
    ssr: false
});
var SectionCover = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(6066), __webpack_require__.e(4447)]).then(__webpack_require__.bind(__webpack_require__, 24447));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24447)
            ];
        }
    },
    ssr: false
});
// SectionHomepageOne is the main highlight = LCP element on a normal visit → SSR it.
var SectionHomepageOne = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return __webpack_require__.e(/* import() */ 158).then(__webpack_require__.bind(__webpack_require__, 30158));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30158)
            ];
        }
    },
    ssr: true
});
var SectionHomepageTwo = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4396), __webpack_require__.e(3714), __webpack_require__.e(2777), __webpack_require__.e(8764), __webpack_require__.e(6244), __webpack_require__.e(7183), __webpack_require__.e(5471), __webpack_require__.e(8300)]).then(__webpack_require__.bind(__webpack_require__, 58300));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58300)
            ];
        }
    },
    ssr: false
});
var SectionHomepageThree = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2777), __webpack_require__.e(7183), __webpack_require__.e(6419)]).then(__webpack_require__.bind(__webpack_require__, 76419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76419)
            ];
        }
    },
    ssr: false
});
var DynamicAds = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84920)
            ];
        }
    },
    ssr: false
});
var SectionMemberNews = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6660), __webpack_require__.e(8764), __webpack_require__.e(1036), __webpack_require__.e(4219)]).then(__webpack_require__.bind(__webpack_require__, 66712));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66712)
            ];
        }
    },
    ssr: false
});
var SectionV = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2777), __webpack_require__.e(7183)]).then(__webpack_require__.bind(__webpack_require__, 37183));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37183)
            ];
        }
    },
    ssr: false
});
var WidgetCardHRTLeft = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2777), __webpack_require__.e(7901)]).then(__webpack_require__.bind(__webpack_require__, 77901));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77901)
            ];
        }
    },
    ssr: false
});
var FiArrowRightCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_8___default()(function() {
    return __webpack_require__.e(/* import() */ 2777).then(__webpack_require__.bind(__webpack_require__, 2777)).then(function(mod) {
        return mod.FiArrowRightCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    },
    ssr: false
});
var PageIndex = function(param) {
    var ads = param.ads, articles = param.articles, coverData = param.coverData, dataLatest = param.dataLatest, articlesTwo = param.articlesTwo, dataLandingPage = param.dataLandingPage, dataAdsHeader = param.dataAdsHeader, dataSetsAll = param.dataSetsAll, sectionCommemorate = param.sectionCommemorate, dataCommemorate = param.dataCommemorate, sectionLive = param.sectionLive, sectionElection = param.sectionElection, dataElection = param.dataElection, sectionWar2026 = param.sectionWar2026, dataWar2026 = param.dataWar2026;
    var ref, ref1, ref2, ref3;
    var user = (0,src_utils_useUser__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), sectionMember = ref4[0], setSectionMember = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), adsBox = ref5[0], setAdsBox = ref5[1];
    var responsive = (0,src_utils_devices__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)();
    var _article = {
        title: (articles === null || articles === void 0 ? void 0 : (ref = articles.metaTag) === null || ref === void 0 ? void 0 : ref.title) || src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_TITLE */ .qN,
        description: (articles === null || articles === void 0 ? void 0 : (ref1 = articles.metaTag) === null || ref1 === void 0 ? void 0 : ref1.description) || src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_DESC */ .a0,
        keyword: (articles === null || articles === void 0 ? void 0 : (ref2 = articles.metaTag) === null || ref2 === void 0 ? void 0 : ref2.keywords) || src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_KEYWORD */ .kG
    };
    var election = {
        title: (0,src_utils_datasets__WEBPACK_IMPORTED_MODULE_16__/* .convertDatasets */ .b$)(sectionElection, "title", true) || "",
        link: (0,src_utils_datasets__WEBPACK_IMPORTED_MODULE_16__/* .convertDatasets */ .b$)(sectionElection, "link", true) || "",
        data: dataElection
    };
    var war2026 = {
        title: (0,src_utils_datasets__WEBPACK_IMPORTED_MODULE_16__/* .convertDatasets */ .b$)(sectionWar2026, "title", true) || "",
        link: (0,src_utils_datasets__WEBPACK_IMPORTED_MODULE_16__/* .convertDatasets */ .b$)(sectionWar2026, "link", true) || "",
        data: dataWar2026
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // console.log('user :', user);
        var checkUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function() {
                var response, _tmp, res;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(user)) return [
                                3,
                                3
                            ];
                            _tmp = {};
                            return [
                                4,
                                fetch("/api/auth/metadata", (_tmp.method = "GET", _tmp.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            res = _state.sent();
                            localStorage.setItem("login-meta-data", res);
                            setSectionMember((0,src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_13__/* .decryptionClient */ .F)(res));
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkUser() {
                return _ref.apply(this, arguments);
            };
        }();
        var loginMetaData = localStorage.getItem("login-meta-data");
        var decryptLoginMetaData = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(loginMetaData) ? (0,src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_13__/* .decryptionClient */ .F)(loginMetaData) : {};
        var expireCondition = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(loginMetaData) ? new Date(decryptLoginMetaData === null || decryptLoginMetaData === void 0 ? void 0 : decryptLoginMetaData.expire) < new Date() : true;
        if (expireCondition) {
            // console.log('เข้า expireCondition');
            checkUser();
        } else {
            // console.log('ไม่เข้า expireCondition');
            setSectionMember(decryptLoginMetaData);
        }
    }, [
        user
    ]);
    var handleLightBoxClick = function() {
        setAdsBox(false);
    };
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        sectionBizelite: [],
        sectionSustainability: []
    }), dataSets = ref6[0], setDataSets = ref6[1];
    var fecthData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function() {
            var _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__.__generator)(this, function(_state) {
                _tmp = {};
                if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(dataSetsAll)) {
                    // const book = convertDatasets(dataSetsAll, 'bookcase', false);
                    setDataSets((_tmp.sectionBizelite = lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(dataSetsAll, {
                        topic: "section-bizelite"
                    }) || [], _tmp.sectionSustainability = lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(dataSetsAll, {
                        topic: "section-sustainability"
                    }) || [], _tmp));
                }
                return [
                    2
                ];
            });
        });
        return function fecthData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        fecthData();
    }, [
        router.isPreview
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_6__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z), {
                title: _article === null || _article === void 0 ? void 0 : _article.title,
                description: _article === null || _article === void 0 ? void 0 : _article.description,
                robotsProps: {
                    maxImagePreview: "large",
                    maxSnippet: -1,
                    maxVideoPreview: -1
                },
                openGraph: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_7__/* ["default"].openGraph */ .Z.openGraph), {
                    title: _article === null || _article === void 0 ? void 0 : _article.title,
                    description: _article === null || _article === void 0 ? void 0 : _article.description
                }),
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: _article === null || _article === void 0 ? void 0 : _article.keyword
                    }
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_9___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "canonical",
                        href: src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_URL.WEB */ .h$.WEB
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:title",
                        content: _article === null || _article === void 0 ? void 0 : _article.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:description",
                        content: _article === null || _article === void 0 ? void 0 : _article.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:image",
                        content: src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .IMAGE_DEFAULT */ .TH
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: '\n                __th_page="home";\n              '
                        }
                    }),
                    !(0,src_utils_device__WEBPACK_IMPORTED_MODULE_17__/* .useDesktop */ .Ln)() && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_mobile)) : "",
                    (0,src_utils_device__WEBPACK_IMPORTED_MODULE_17__/* .useDesktop */ .Ln)() && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_desktop)) : "",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        async: true,
                        type: "text/javascript",
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: "var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n                          {\n                            "@context": "https://schema.org",\n                            "@type": "WebSite",\n                            "name": "'.concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_NAME */ .Ey, '",\n                            "url": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_URL.WEB */ .h$.WEB, '",\n                            "description": "').concat(_article === null || _article === void 0 ? void 0 : _article.description, '",\n                            "sameAs": [\n                              "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_URL.FACEBOOK */ .h$.FACEBOOK, '",\n                              "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_URL.TWITTER */ .h$.TWITTER, '",\n                              "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_URL.INSTAGRAM */ .h$.INSTAGRAM, '",\n                              "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_URL.YOUTUBE */ .h$.YOUTUBE, '",\n                              "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_URL.LINE */ .h$.LINE, '"\n                            ],\n                            "potentialAction": {\n                              "@type": "SearchAction",\n                              "target": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_URL.WEB */ .h$.WEB, 'search?q={search_term_string}",\n                              "query-input": "required name=search_term_string"\n                            }\n                          }\n                        }\n                      ')
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n                  {\n                    "@context": "http://schema.org",\n                    "@type": "WebPage",\n                    "name": "'.concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_NAME */ .Ey, '",\n                    "description": "').concat(_article === null || _article === void 0 ? void 0 : _article.description, '",\n                    "publisher": {\n                      "@type": "ProfilePage",\n                      "name": "').concat(src_constants_layout__WEBPACK_IMPORTED_MODULE_12__/* .WEB_NAME */ .Ey, '"\n                    }\n                  }\n                ')
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: SectionLandingPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionLandingPage, {
                    data: dataLandingPage
                })
            }),
            !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(coverData) && src_constants__WEBPACK_IMPORTED_MODULE_11__/* .SHOW_SECTIONCOVER_TOP */ .v4 === "true" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "default-cover",
                    children: SectionCover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionCover, {
                        data: coverData
                    })
                })
            }),
            !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(sectionCommemorate) && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(dataCommemorate) && src_constants__WEBPACK_IMPORTED_MODULE_11__/* .SHOW_RIBBON */ .zC === "true" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionWrapper, {
                style: {
                    filter: src_constants__WEBPACK_IMPORTED_MODULE_11__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                },
                children: SectionSpacial && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionSpacial, {
                    id: "spacial-commemorate",
                    data: sectionCommemorate,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "container spacial-grid",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "spacial-grid-list",
                                children: SectionV && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionV, {
                                    spacial: sectionCommemorate,
                                    showSpacial: false,
                                    showheading: false,
                                    count: !responsive.isMobile ? 4 : 3,
                                    badge: false,
                                    withTarget: true,
                                    data: dataCommemorate,
                                    heading: (0,src_utils_datasets__WEBPACK_IMPORTED_MODULE_16__/* .convertDatasets */ .b$)(sectionCommemorate, "ชื่อแท็ก", true),
                                    path: "",
                                    //! DATALAYER
                                    eventDataLayer: {
                                        type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_15__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                        section: "section-commemorate",
                                        data: {
                                            heading: (0,src_utils_datasets__WEBPACK_IMPORTED_MODULE_16__/* .convertDatasets */ .b$)(sectionCommemorate, "ชื่อแท็ก", true)
                                        }
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                            href: "".concat((0,src_utils_datasets__WEBPACK_IMPORTED_MODULE_16__/* .convertDatasets */ .b$)(sectionCommemorate, "link", true)),
                            className: "more",
                            children: [
                                "ดูทั้งหมด ",
                                FiArrowRightCircle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FiArrowRightCircle, {})
                            ]
                        })
                    ]
                })
            }),
            Layout && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Layout, {
                ads: ads,
                children: [
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(coverData) && src_constants__WEBPACK_IMPORTED_MODULE_11__/* .SHOW_SECTIONCOVER_TOP */ .v4 === "false" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "default-cover",
                            children: SectionCover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionCover, {
                                data: coverData
                            })
                        })
                    }),
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(ads) && DynamicAds && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_14__.KEY_ADS_POSITION.LIGHTBOX,
                        data: ads,
                        handler: function() {
                            return handleLightBoxClick();
                        },
                        adsBox: adsBox
                    }),
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(ads) && ads.find(function(a) {
                        return (a === null || a === void 0 ? void 0 : a.position) === src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_14__.KEY_ADS_POSITION.BILLBOARD;
                    }) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        style: {
                            minHeight: 300
                        },
                        children: DynamicAds && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                            position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_14__.KEY_ADS_POSITION.BILLBOARD,
                            data: ads
                        })
                    }),
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(sectionMember) && SectionMemberNews && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionMemberNews, {
                        data: {
                            user: (ref3 = (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_19__/* .dropSomeField */ .ny)(sectionMember, [
                                "menu",
                                "tags",
                                "articlesTags",
                                "articlesCategories"
                            ])) === null || ref3 === void 0 ? void 0 : ref3.user,
                            menu: sectionMember === null || sectionMember === void 0 ? void 0 : sectionMember.menu,
                            tags: sectionMember === null || sectionMember === void 0 ? void 0 : sectionMember.tags,
                            articlesTags: sectionMember === null || sectionMember === void 0 ? void 0 : sectionMember.articlesTags,
                            articlesCategories: sectionMember === null || sectionMember === void 0 ? void 0 : sectionMember.articlesCategories,
                            latest: dataLatest === null || dataLatest === void 0 ? void 0 : dataLatest.data
                        }
                    }),
                    SectionHomepageOne && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionHomepageOne, {
                        id: "section-1",
                        data: articles,
                        lastestNews: dataLatest === null || dataLatest === void 0 ? void 0 : dataLatest.data,
                        sectionLive: sectionLive,
                        //! DATALAYER
                        eventDataLayer: {
                            type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_15__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                            router: router === null || router === void 0 ? void 0 : router.pathname,
                            section: "section-1",
                            position: "ใต้:โฆษณาตำแหน่งที่ Billboard"
                        }
                    }),
                    WidgetCardHRTLeft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WidgetCardHRTLeft, {
                        id: "section-spacial",
                        sectionData: sectionWar2026,
                        article: war2026,
                        limit: 3,
                        eventDataLayer: {
                            type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_15__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                            router: router === null || router === void 0 ? void 0 : router.pathname,
                            section: "section-spacial",
                            position: "ใต้:section-1"
                        },
                        isShowHeader: false
                    }),
                    SectionHomepageTwo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionHomepageTwo, {
                        block1: articles === null || articles === void 0 ? void 0 : articles.block1,
                        block2: articles === null || articles === void 0 ? void 0 : articles.block2,
                        block3: articles === null || articles === void 0 ? void 0 : articles.block3,
                        block4: articlesTwo === null || articlesTwo === void 0 ? void 0 : articlesTwo.block1,
                        // sectionBizelite={dataSets?.sectionBizelite}
                        sectionWorldcup: lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(dataSetsAll, {
                            topic: "section-worldcup"
                        }),
                        sectionGlobalDialogue: lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(dataSetsAll, {
                            topic: "section-global-dialogue"
                        }),
                        sectionNewHorizon: lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(dataSetsAll, {
                            topic: "section-new-horizon"
                        }),
                        sectionSustainability: dataSets === null || dataSets === void 0 ? void 0 : dataSets.sectionSustainability,
                        highlight: articles === null || articles === void 0 ? void 0 : articles.newHighlight2,
                        eventDataLayer: {
                            type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_15__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                            router: router === null || router === void 0 ? void 0 : router.pathname
                        }
                    }),
                    SectionHomepageThree && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionHomepageThree, {
                        sectionYoutube: dataSets === null || dataSets === void 0 ? void 0 : dataSets.sectionYoutube,
                        sectionBizelite: dataSets === null || dataSets === void 0 ? void 0 : dataSets.sectionBizelite,
                        eventDataLayer: {
                            type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_15__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                            router: router === null || router === void 0 ? void 0 : router.pathname
                        }
                    }),
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(ads) && DynamicAds && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_14__.KEY_ADS_POSITION.POSTARTICLE,
                        data: ads
                    }),
                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(ads) && DynamicAds && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_14__.KEY_ADS_POSITION.AD1X1,
                        data: ads
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PageIndex);
var SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_25__["default"].div(_templateObject());


/***/ }),

/***/ 34871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b$": function() { return /* binding */ convertDatasets; }
/* harmony export */ });
/* unused harmony exports ModifyMenu, convertDatasetsLists, convertDataLists, convertDataListsNonNullCount */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);




function convertDatasets(data, topic, isValue) {
    if (lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data)) return null;
    var results = [];
    if (isValue) {
        for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i++){
            var ref, ref1;
            if (data === null || data === void 0 ? void 0 : (ref = data[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.key) === null || ref1 === void 0 ? void 0 : ref1.startsWith(topic)) {
                var ref2;
                results === null || results === void 0 ? void 0 : results.push(data === null || data === void 0 ? void 0 : (ref2 = data[i]) === null || ref2 === void 0 ? void 0 : ref2.value);
            }
        }
    } else {
        for(var i1 = 0; i1 < (data === null || data === void 0 ? void 0 : data.length); i1++){
            var ref3, ref4;
            if (data === null || data === void 0 ? void 0 : (ref3 = data[i1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.topic) === null || ref4 === void 0 ? void 0 : ref4.startsWith(topic)) {
                var ref5;
                results === null || results === void 0 ? void 0 : results.push(data === null || data === void 0 ? void 0 : (ref5 = data[i1]) === null || ref5 === void 0 ? void 0 : ref5.dataSet);
            }
        }
    }
    return isValue ? results[0] : results;
}
function ModifyMenu(_array) {
    if (!Array.isArray(_array) || !_array) return [];
    return Array.isArray(_array) && _array.reduce(function(acc, cur) {
        var indexEl = _array.findIndex(function(el) {
            return el.nameEng.indexOf("lottery") && cur.nameEng.indexOf("lottery");
        });
        if (indexEl !== -1) {
            return _to_consumable_array(acc).concat([
                _object_spread({}, cur)
            ]);
        } else {
            return _to_consumable_array(acc).concat([
                _object_spread_props(_object_spread({}, cur), {
                    sub: []
                })
            ]);
        }
    }, []);
}
function convertDatasetsLists(data, topic) {
    var results = [];
    data.forEach(function(el) {
        var indexEl = topic.indexOf(el.key);
        if (indexEl !== -1) {
            return results.push(el.value);
        }
    }, []);
    return results;
}
function sortDataByKey(data) {
    return data.sort(function(a, b) {
        var ref, ref1;
        var numA = parseInt(((ref = a.key.match(/\d+$/)) === null || ref === void 0 ? void 0 : ref[0]) || 0, 10);
        var numB = parseInt(((ref1 = b.key.match(/\d+$/)) === null || ref1 === void 0 ? void 0 : ref1[0]) || 0, 10);
        return numA - numB;
    });
}
function convertDataLists(data, keys) {
    var result = {};
    var sortData = sortDataByKey(data);
    keys.forEach(function(key) {
        var keyData = sortData.filter(function(item) {
            return item.key.startsWith(key);
        });
        var values = keyData.map(function(item) {
            return item.value;
        });
        result[key.substring(0, key.length - 1)] = values;
    });
    return result;
}
function convertDataListsNonNullCount(data, keys) {
    var result = {};
    var sortData = sortDataByKey(data);
    keys.forEach(function(key) {
        var keyData = sortData.filter(function(item) {
            return item.key.startsWith(key);
        });
        var values = keyData.map(function(item) {
            return item.value;
        });
        var nonNullCount = values.filter(function(value) {
            return value !== null;
        }).length;
        result[key.substring(0, key.length - 1)] = {
            values: values,
            nonNullCount: nonNullCount
        };
    });
    return result;
}


/***/ }),

/***/ 97348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_1__);


var useResponsive = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isClient = ref[0], setIsClient = ref[1];
    var isMobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "690px"
    });
    var isTabletMini = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "767px"
    });
    var isLaptopMini = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "768px"
    });
    var isTablet = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "900px"
    });
    var isLaptop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "691px"
    });
    var isDesktop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "1024px"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (true) setIsClient(true);
    }, []);
    return {
        isDesktop: isClient ? isDesktop : true,
        isLaptop: isClient ? isLaptop : true,
        isTablet: isClient ? isTablet : false,
        isMobile: isClient ? isMobile : false,
        isTabletMini: isClient ? isTabletMini : false,
        isLaptopMini: isClient ? isLaptopMini : false
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useResponsive);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [601,7817,6126,106,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);